const modalDeactive = $('#modal-deactive-id');
const wrongEmail = $('#wrong-email');
const submitDeactive = $('#confirm-delete-button');
const modalContentForm = $('#ModalContentForm');
const modalContentInfo = $('#ModalContentInfo');
const deactiveForm = $('#DeactiveFormEcommerce');
const confirmDeactiveBtn = $('#confirmDeactive');
const wrapInput = deactiveForm.find('.js-form-wrap');
const closeAccConfirmIcon = $('.js-close-deactive-confirm');

$(document).on('keyup', function (e) {
    if (e.key == "Escape" && !modalDeactive.hasClass('cc-modalDialogClose')) {
        modalDeactive.addClass('cc-modalDialogClose')
        if (modalContentForm.hasClass('d-none'))
            modalContentForm.removeClass('d-none');
        if (!modalContentInfo.hasClass('d-none'))
            modalContentInfo.addClass('d-none');
    }
});

//PWC-NOA-1260 create function for handle submit of deactivate customer form
deactiveForm.on('submit', function (event) {
    event.preventDefault();
    $('body').spinner().start();
    var form = $(this);
    var data = form.serialize();
    var emailInput = $(wrapInput).find('input');
    var wrongEmailErrorMessage = $(emailInput).data('pattern-mismatch');
    var feedbackElement = $(emailInput).closest('.cc-form__wrap').find('.invalid-feedback');
    data += '&' + submitDeactive.attr('name') + '=';
    if (data.indexOf('ajax') === -1)
        data += '&format=ajax';

    $.ajax({
        type: 'POST',
        url: form.attr('action'),
        data: data,
        success: function (response) {
            modalContentForm.addClass('d-none');
            modalContentInfo.removeClass('d-none');

            setTimeout(function () {
                $('body').spinner().start();

                window.location.href = response.redirectUrl;
            }, 3000);
        },
        error: function () {
            modalContentForm.removeClass('d-none');
            modalContentInfo.addClass('d-none');
            feedbackElement.text(wrongEmailErrorMessage);
            wrapInput.addClass('cc-form__wrap--error')
            $('body').spinner().stop();
        }
    }).fail(function () {
        modalContentForm.removeClass('d-none');
        modalContentInfo.addClass('d-none');
        feedbackElement.text(wrongEmailErrorMessage);
        wrongEmail.removeClass('d-none');
        $('body').spinner().stop();
    });
});

$('.js-close-button-deactive-id').on('click', function () {
    $('#ModalContentForm').removeClass('d-none');
    $('#ModalContentInfo').addClass('d-none');
    $('#modal-deactive-id').addClass('cc-modalDialogClose');
});

$('#delete-account-button-id').on('click', function () {
    $('#modal-deactive-id').removeClass('cc-modalDialogClose');
    $('div.modal-input-email').find('#dwfrm_profile_customer_email').val('')
});